import React from "react";

const PlayIcon = ({ color, className }) => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="36" cy="36" r="35.5" stroke={color} />
    <path
      d="M43.6844 33.7714L30.3533 24.645C29.7376 24.2232 29.1173 24 28.6017 24C27.6049 24 26.9883 24.8 26.9883 26.1391V45.864C26.9883 47.2015 27.6041 48 28.5986 48C29.115 48 29.7254 47.7766 30.3424 47.3536L43.6797 38.2274C44.5374 37.6396 45.0124 36.8485 45.0124 35.9989C45.0126 35.15 44.5431 34.3591 43.6844 33.7714Z"
      fill={color}
    />
  </svg>
);

PlayIcon.defaultProps = {
  color: "#fff",
};

export default PlayIcon;
